import {
  normalizeNodeIcon,
  normalizeNodeImportance,
  normalizeNodeResources,
} from "./nodeContent.js";
export function toEditorNode(
  node,
  { type = "custom", position = node.position || { x: 0, y: 0 } } = {},
) {
  const raw = node.data || node;
  return {
    id: String(node.id),
    type,
    position: { ...position },
    data: {
      label: raw.label || "",
      description: raw.description || "",
      is_core: Boolean(raw.is_core),
      importance: normalizeNodeImportance(raw.importance, raw.is_core),
      resources: normalizeNodeResources(raw.resources),
      icon: normalizeNodeIcon(raw.icon),
      related_node_ids: raw.related_node_ids || [],
      semantic_data: raw.semantic_data || {},
    },
  };
}
export function toEditorEdge(edge) {
  return {
    ...edge,
    data: {
      ...(edge.data || {}),
      semantic_data: edge.semantic_data || edge.data?.semantic_data || {},
    },
  };
}
